export default __webpack_public_path__ + "static/media/PoweredByLinko.dc7e473a.png";